// export let pluginConfig = {
//   lang: 'en',
//   position: 'bottom-right',
//   offset: [20, 20],
//   size: 58
// };

import type { IconItem, WidgetConfig } from "../types/widget";
import { Accessibility, Eye, Settings, Palette } from "lucide-react";
import { defaultConfig } from "./defaultConfig";

// Re-exported so existing `import { defaultConfig } from "@/globals/pluginConfig"`
// call sites keep working unchanged; the canonical data now lives in
// ./defaultConfig (pure data, safe for the CDN loader bundle to import).
export { defaultConfig };

export const ICON_LIBRARY: IconItem[] = [
  { id: "accessibility", icon: Accessibility, name: "Accessibility" },
  { id: "eye", icon: Eye, name: "Eye" },
  { id: "settings", icon: Settings, name: "Settings" },
  { id: "palette", icon: Palette, name: "Palette" },
];

export const POSITION_OPTIONS = [
  { value: "top-left", label: "Top Left" },
  { value: "top-right", label: "Top Right" },
  { value: "bottom-left", label: "Bottom Left" },
  { value: "bottom-right", label: "Bottom Right" },
];

export const TEXT_ALIGNMENT_OPTIONS = [
  { value: "left", label: "Left" },
  { value: "center", label: "Center" },
  { value: "right", label: "Right" },
];

declare global {
  interface Window {
    _cyA11yConfig?: WidgetConfig;
  }
}

const _remote = window._cyA11yConfig;
export const pluginConfig: WidgetConfig = {
  ...defaultConfig,
  ..._remote,
  keyboard: {
    ...defaultConfig.keyboard,
    ...(_remote?.keyboard || {}),
  },
  modules: {
    color: {
      ...defaultConfig.modules.color,
      ...(_remote?.modules?.color || {}),
    },
    content: {
      ...defaultConfig.modules.content,
      ...(_remote?.modules?.content || {}),
    },
    navigation: {
      ...defaultConfig.modules.navigation,
      ...(_remote?.modules?.navigation || {}),
    },
    statement: {
      ...defaultConfig.modules.statement,
      ...(_remote?.modules?.statement || {}),
    },
    profiles: {
      ...defaultConfig.modules.profiles,
      ...(_remote?.modules?.profiles || {}),
    },
    pageRead: {
      ...defaultConfig.modules.pageRead,
      ...(_remote?.modules?.pageRead || {}),
    },
    muteSounds: {
      ...defaultConfig.modules.muteSounds,
      ...(_remote?.modules?.muteSounds || {}),
    },
  },
};